export const getUpdatedValue = <T, U>(current:U, incoming:T, selectedVases: number[], formatter: (curr: U, inc: T, sv: number[]) => void) => {
    if (!incoming) {
        return current;
    }
    return formatter(current, incoming, selectedVases);
};
